import { ReactNode, createContext, useContext, useMemo, useState } from 'react';

interface GoldenSummaryContextType {
  hasPendingChanges: boolean;
  setHasPendingChanges: (value: boolean) => void;
  clearPendingChanges: () => void;
}

const GoldenSummaryContext = createContext<
  GoldenSummaryContextType | undefined
>(undefined);

interface GoldenSummaryContextProviderProps {
  children: ReactNode;
}

export const GoldenSummaryContextProvider = ({
  children,
}: GoldenSummaryContextProviderProps) => {
  const [hasPendingChanges, setHasPendingChanges] = useState(false);

  const clearPendingChanges = () => setHasPendingChanges(false);

  const value = useMemo(
    () => ({ hasPendingChanges, setHasPendingChanges, clearPendingChanges }),
    [hasPendingChanges],
  );

  return (
    <GoldenSummaryContext.Provider value={value}>
      {children}
    </GoldenSummaryContext.Provider>
  );
};

export const useGoldenSummaryContext = (): GoldenSummaryContextType => {
  const context = useContext(GoldenSummaryContext);

  if (!context) {
    throw new Error(
      'useGoldenSummaryContext must be used within a GoldenSummaryProvider',
    );
  }

  return context;
};
